import * as Yup from 'yup';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Link, Stack, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFTextField, RHFCheckbox } from '../../../components/hook-form';
import { useDispatch, useSelector } from "react-redux";
import { request_restore_password } from '../../../actions/auth';
import { setToken, fetchToken } from '../../../Auth.js'

const axios = require('axios');
// ----------------------------------------------------------------------

export default function RequestRestorePasswordForm() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const { isLoggedIn } = useSelector(state => state.auth);
    const { message } = useSelector(state => state.message);

    const dispatch = useDispatch();

    const LoginSchema = Yup.object().shape({
        email: Yup.string(),
        botcode: Yup.string()
    });

    const defaultValues = {
        email: '',
        botcode: '',
    };

    const methods = useForm({
        resolver: yupResolver(LoginSchema),
        defaultValues,
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const onSubmit = async () => {
        const email = methods.getValues().email
        const botcode = methods.getValues().botcode
        if (email === '' && botcode === '') {
            return
        } else {

            dispatch(request_restore_password(email, botcode))
                .then(() => {
                    // navigate("/restore-password");
                    // window.location.reload();
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    };



    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={3}>
                <RHFTextField name="email" label="Email address" />



                <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
                    Request password
                </LoadingButton>
            </Stack>

            {message && (
                <div className="form-group">
                    <div className="alert alert-danger" role="alert">
                        {message}
                    </div>
                </div>
            )}
        </FormProvider>
    );
}
